import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface Category {
  id: number;
  name: string;
  slug: string;
  description?: string;
  image?: string;
  parent_id: number | null;
  active: boolean;
  parent?: Category;
  children?: Category[];
  products_count?: number;
}

export const categoryService = {
  getAll: (params?: any) => api.get(API_ENDPOINTS.CATEGORIES.INDEX, { params }),
  
  create: (data: { name: string; description?: string; image?: string; parent_id?: number | null; active?: boolean }) => 
    api.post(API_ENDPOINTS.CATEGORIES.STORE, data),
  
  update: (id: number, data: { name?: string; description?: string; image?: string; parent_id?: number | null; active?: boolean }) => 
    api.put(API_ENDPOINTS.CATEGORIES.UPDATE(id), data),
  
  delete: (id: number) => 
    api.delete(API_ENDPOINTS.CATEGORIES.DELETE(id)),
};
